import React, { Component } from 'react'
import styled from 'styled-components'
import { Container, Row, Col } from 'styled-bootstrap-grid'
import InViewMonitor from 'react-inview-monitor'
import easing from 'ui/styles/easing'

import Accordion from './Accordion'

const Wrapper = styled.div`
  margin-bottom: 80px;
  transform: ${props => props.inView ? 'translateY(0px)' : 'translateY(30px)'};
  opacity: ${props => props.inView ? 1 : 0};
  transition: transform 0.6s ${easing.easeOutCubic}, opacity 0.6s ${easing.easeOutCubic};
`
const Title = styled.h2`
  font-size: 32px;
  color: ${props => props.theme.colors.theme.base};
`

export default class Accordions extends Component {
  render() {
    const {
      title,
      accordions
    } = this.props

    return (
      <InViewMonitor childPropsInView={{inView: true}}>
        <Wrapper>
          <Container fluid>
            {title &&
              <Row>
                <Col
                  sm={9}
                  smOffset={1}
                  lgOffset={2}
                  xl={7}
                >
                  <Title>{title}</Title>
                </Col>
              </Row>
            }
            {accordions.map((accordion, index) => {
              return(
                <Row key={index}>
                  <Col
                    sm={9}
                    smOffset={1}
                    lgOffset={2}
                    xl={7}
                  >
                    <Accordion {...accordion} />
                  </Col>
                </Row>
              )
            })}
          </Container>
        </Wrapper>
      </InViewMonitor>
    )
  }
}



// WEBPACK FOOTER //
// ./src/ui/components/modules/Accordions/index.js